if (!customElements.get('mobile-menu')) {
  class MobileMenu extends HTMLElement {
    constructor() {
      super();

      // Store Locator Button Logic
      this.storeLocatorBtn = this.querySelector('[announcement-store-locator]');
      if (this.storeLocatorBtn) {
        this.storeLocatorBtn.addEventListener('click', () => {
          const store_locator = document.querySelector('store-locator-drawer');
          if (store_locator) {
            store_locator.setAttribute('drawer-open', '');
            setTimeout(() => {
              store_locator.classList.add('drawer-open');
            }, 500);
          }
        });
      }

      // Accordion open/close on focus
      this.detailsElements = this.querySelectorAll('details');

      this.detailsElements.forEach((details) => {
        // Open when focused
        //  details.addEventListener('click', (e) => {
        //   if (e.target.tagName === 'A' || e.target.closest('a')) return;
        //   e.preventDefault()
        details.addEventListener('click', (e) => {
          if (!e.target.closest('[data-submenu-toggle]')) return;
          e.preventDefault()
           if (details.getAttribute('open')) {
              details.removeAttribute('open');
              return;
            }
           this.detailsElements.forEach((removeAttribute)=>{
            removeAttribute.removeAttribute('open');
           })
          details.setAttribute('open', '');
        });
        // details.addEventListener('focusin', () => {
        //   details.setAttribute('open', '');
        // });

        // Close when focus leaves (not when clicking inside)
        // details.addEventListener('focusout', (event) => {
        //   // Use setTimeout so it triggers after focus actually leaves the element
        //   setTimeout(() => {
        //     if (!details.contains(document.activeElement)) {
        //       details.removeAttribute('open');
        //     }
        //   }, 0);
        // });
      });

      this.initMobileMenuTabs();
    }

    initMobileMenuTabs() {
      const mobileMenuTabs = this.querySelectorAll('[data-category-tab]');
      const mobileMenuTabsContent = this.querySelectorAll('[data-category-content]');
      mobileMenuTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          mobileMenuTabs.forEach((t) => {
            t.classList.remove('active');
          });
          tab.classList.add('active');
          mobileMenuTabsContent.forEach((content) => {
            content.classList.remove('active');
          });
          mobileMenuTabsContent[index].classList.add('active');
        });
      });
    }
  }

  customElements.define('mobile-menu', MobileMenu);
}
